/**
 * 手書きペン設定
 */
import { DrawSettings } from '@/models/drawSettings'

export class PenSettings {
  /** ペン太さ規定値 */
  private static readonly WIDTH_PEN = 5
  /** 消しゴム太さ規定値 */
  private static readonly WIDTH_ERASER = 15
  /** 手書きキャンバスペン太さ規定値 */
  public static readonly WIDTH_TEGAKI_PEN = 2
  /** 蛍光ペン太さ規定値 */
  public static readonly WIDTH_HIGHLIGHTER = 10
  /** 黒色の規定値 */
  public static readonly COLOR_BLACK = '#333333'
  /** 透明度100%の規定値 */
  public static readonly ALPHA_100 = 1

  /**
   * 黒ペン
   */
  public static readonly PEN_BLACK: DrawSettings.PenAsset = {
    name: 'black',
    operation: DrawSettings.Operations.WRITE_OVER,
    lineCap: DrawSettings.LineCap.ROUND,
    lineWidth: PenSettings.WIDTH_PEN,
    color: PenSettings.COLOR_BLACK,
  }

  /**
   * 赤ペン
   */
  public static readonly PEN_RED: DrawSettings.PenAsset = {
    name: 'red',
    operation: DrawSettings.Operations.WRITE_OVER,
    lineCap: DrawSettings.LineCap.ROUND,
    lineWidth: PenSettings.WIDTH_PEN,
    color: '#DC361B',
  }

  /**
   * マーカー(蛍光ペン)
   */
  public static readonly PEN_HIGHLIGHT: DrawSettings.PenAsset = {
    name: 'highlight',
    operation: DrawSettings.Operations.WRITE_OVER,
    lineCap: DrawSettings.LineCap.ROUND,
    lineWidth: PenSettings.WIDTH_HIGHLIGHTER,
    color: '#EC8B4C',
    alpha: 0.3,
  }

  /**
   * 消しゴム
   */
  public static readonly ERASER: DrawSettings.PenAsset = {
    name: 'eraser',
    operation: DrawSettings.Operations.REMOVE_OVER,
    lineCap: DrawSettings.LineCap.ROUND,
    lineWidth: PenSettings.WIDTH_ERASER,
  }

  /**
   * 手書きキャンバスペン
   */
  public static readonly TEGAKI_PEN: DrawSettings.TegakiPenAsset = {
    lineCap: DrawSettings.LineCap.ROUND,
    lineJoin: DrawSettings.LineJoin.ROUND,
    lineWidth: PenSettings.WIDTH_TEGAKI_PEN,
    color: PenSettings.COLOR_BLACK,
  }

  /**
   * 手書きキャンバス消しゴム
   */
  public static readonly TEGAKI_ERASER: DrawSettings.TegakiPenAsset = {
    lineCap: DrawSettings.LineCap.ROUND,
    lineJoin: DrawSettings.LineJoin.ROUND,
    lineWidth: PenSettings.WIDTH_TEGAKI_PEN,
    color: '#ff0000',
  }
}
